<template>
    <div>
        <vue-ueditor-wrap v-model="editor_text" :config="editorConfig" editor-id="editor-demo-01" @ready="onEditorReady" @before-init="addCustomButton" />
        <upload ref="uploadRef" dir="images" v-model="files" v-model:checkedData="files_path" button="上传单张图片" :is-ueditor="true" :is-multiple="true" />
    </div>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, watch } from 'vue'
    import Upload from '@/components/ui-upload'
    import Utils from '@/utils/util'

    export default defineComponent({
        components: {
            Upload
        },
        props: {
            modelValue: {
                type: [Number, String],
                default: ''
            }
        },
        setup(props, context) {
            const editorConfig = {
                UEDITOR_HOME_URL: '/ueditor/',
                autoFloatEnabled: false,
                initialFrameWidth: 1000,
                initialFrameHeight: 500,
                minFrameWidth: 1000,
                minFrameHeight: 500,
                autoHeightEnabled: false,
                // serverUrl: '//ueditor.szcloudplusaaaa.com/cos',
                toolbars: [[
                    'fullscreen',
                    'source',
                    '|',
                    'undo',
                    'redo',
                    '|',
                    'bold',
                    'italic',
                    'underline',
                    'fontborder',
                    'strikethrough',
                    'superscript',
                    'subscript',
                    'removeformat',
                    'formatmatch',
                    'autotypeset',
                    'blockquote',
                    'pasteplain',
                    '|',
                    'forecolor',
                    'backcolor',
                    'insertorderedlist',
                    'insertunorderedlist',
                    'selectall',
                    'cleardoc',
                    '|',
                    'rowspacingtop',
                    'rowspacingbottom',
                    'lineheight',
                    '|',
                    'insertcode',
                    'customstyle',
                    'paragraph',
                    'fontfamily',
                    'fontsize',
                    '|',
                    'directionalityltr',
                    'directionalityrtl',
                    'indent',
                    '|',
                    'justifyleft',
                    'justifycenter',
                    'justifyright',
                    'justifyjustify',
                    '|',
                    'touppercase',
                    'tolowercase',
                    '|',
                    'link',
                    'unlink',
                    'anchor',
                    '|',
                    'imagenone',
                    'imageleft',
                    'imageright',
                    'imagecenter',
                    '|',
                    // 'simpleupload',
                    // 'insertimage',
                    // 'attachment',
                    'emotion',
                    'map',
                    'insertframe',
                    'pagebreak',
                    'template',
                    '|',
                    'horizontal',
                    'date',
                    'time',
                    'spechars',
                    'snapscreen',
                    'wordimage',
                    '|',
                    'inserttable',
                    'insertparagraphbeforetable',
                    'insertrow',
                    'insertcol',
                    'mergecells',
                    'mergeright',
                    'mergedown',
                    'splittocells',
                    'splittorows',
                    'splittocols',
                    'charts',
                    'deletetable',
                    'deleterow',
                    'deletecol',
                    '|',
                    'print',
                    'preview',
                    'searchreplace',
                    'drafts',
                    'help'
                ]]
            }
            const editor_text = ref()
            editor_text.value = props.modelValue
            return {
                editorConfig,
                editor_text
            }
        },
        data() {
            return {
                editor: '',
                files: '',
                files_path: ''
            }
        },
        watch: {
            editor_text(newv, oldv) {
                this.$emit('update:modelValue', newv)
            },
            files(newv, oldv) {
                if (newv !== '') {
                    let files = this.files_path.split(',')
                    let str = ''
                    files.forEach((item, index) => {
                        str += `<p><img src="${Utils.getImgUrl(item)}"/></p>`
                    })
                    this.editor.execCommand('inserthtml', str)
                    this.files_path = ''
                    this.files = ''
                }
            }
        },
        methods: {
            onEditorReady(editor) {
                this.editor = editor
            },
            addCustomButton(editorId) {
                let _this = this
                window.UE.registerUI(
                    'insertimage',
                    (editor, uiName) => {
                        // 创建一个 button
                        const btn = new window.UE.ui.Button({
                            // 按钮的名字
                            name: uiName,
                            // 提示
                            title: '上传图片',
                            // 点击时执行的命令
                            onclick() {
                                _this.$refs.uploadRef.upButton()
                            }
                        })
                        return btn
                    },
                    57,
                    editorId
                )
            }
        }
    })
</script>

<style>
    .edui-default .edui-toolbar{ line-height: initial;}
</style>
